"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.complete.hero.title': 'Witamy w IntHub!',
    'register.complete.hero.description': 'Twoje konto zostało pomyślnie utworzone. Sprawdź swoją pocztę e-mail, aby aktywować konto.',
    'register.complete.title': 'Rejestracja pomyślna!',
    'register.complete.description': 'Dziękujemy za dołączenie do IntHub. Wysłaliśmy e-mail aktywacyjny na Twój adres.',
    'register.complete.email.check': 'Sprawdź swoją skrzynkę odbiorczą i kliknij link aktywacyjny, aby ukończyć rejestrację.',
    'register.complete.login.button': 'Przejdź do logowania',
    'register.complete.home.button': 'Powrót do strony głównej',
    'register.complete.help.text': 'Potrzebujesz pomocy?',
    'register.complete.help.link': 'Skontaktuj się z pomocą',
    'register.complete.email.sent': 'Email wysłany do',
    'register.complete.button.login': 'Idź do Logowania',
    'register.complete.button.resend': 'Wyślij ponownie Email Aktywacyjny',
    'register.complete.help.check_spam': 'Sprawdź folder spam, jeśli nie widzisz emaila w skrzynce odbiorczej.',
    'register.complete.help.contact_support': 'Jeśli potrzebujesz pomocy, skontaktuj się z naszym zespołem wsparcia.',
    'register.complete.resend.success': 'Email aktywacyjny wysłany ponownie pomyślnie!',
};
